if (!customElements.get('g-logo-list')) {
  class MLogoList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === 'true';
      if (!enableSlider) return;
      const wrapper = this.querySelector('[data-wrapper]');
      wrapper.classList.add('swiper-wrapper');
      this.device = this.dataset.device;
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === 'true';
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const items = parseInt(this.dataset.items);
      const slideContainer = this.querySelector('.swiper-container');
      if (slideContainer) {
        this.slider = new GkifyLibs.Swiper(slideContainer, {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: items,
            },
          },
        });
      }
    }
    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define('g-logo-list', MLogoList);
}
